import React from 'react';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { Maximize2 } from 'lucide-react';
import styles from './ClosedDayStrip.module.scss';

const ClosedDayStrip = ({ day, showHeader, onExpand }) => {
  const { t } = useTranslation();
  const label = dayjs(day.date).format('ddd D');

  return (
    <div
      className={styles.closed_day_strip}
      aria-label={`${label} · ${t('scheduler.closures.closed')}`}
    >
      {showHeader ? (
        <div className={styles.closed_day_strip_header}>{dayjs(day.date).format('dddd DD')}</div>
      ) : null}
      <button
        type="button"
        className={styles.closed_day_strip_card}
        style={{ top: showHeader ? 58 : 8 }}
        onClick={onExpand}
        title={t('scheduler.closures.bookAnyway')}
      >
        <span className={styles.closed_day_strip_date}>{label}</span>
        <span className={styles.closed_day_strip_status}>{t('scheduler.closures.closed')}</span>
        <span className={styles.closed_day_strip_action}>
          <Maximize2 size={12} strokeWidth={2.4} aria-hidden />
          {t('scheduler.closures.expandToBook')}
        </span>
      </button>
    </div>
  );
};

export default ClosedDayStrip;
